import Node from './Node';

import type { BaseExpression, ParentContext } from '../types';
import type Context from '../Context';

export default class ValueNode<T extends BaseExpression> extends Node<T> {
    /* @override */
    async execute(_context: Context, _config: ParentContext): Promise<any> {
        throw new Error('override me');
    }
}
